import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import AbrirChamado from '../pages/chamados/abrirChamado';
import AtendimentoChamados from '../pages/chamados/atendimentoChamados';
import MeusChamados from '../pages/chamados/meusChamados';

const RouteChamados = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='Chamados'/>}>
                <Route path='abrirChamado' element={<AbrirChamado/>}/>
                <Route path='meusChamados' element={<MeusChamados/>}/>
            </Route>
            <Route element={<ProtectedRoute roleIncludes={['Atendente']}/>}>
                <Route path='atendimentoChamados' element={<AtendimentoChamados/>}/>
            </Route>
        </Routes>
    );
};

export default RouteChamados;
